// extracted by mini-css-extract-plugin
export default {"location":"LocationMark_location__dWa+b"};